// extracted by mini-css-extract-plugin
export default {"Box":"empty-column-sash-module__Box--j0xDF"};